import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { connect } from 'react-redux'
import OpenOrders from '../../components/exchange/OpenOrders'
import OrderHistory from '../../components/exchange/OrderHistory'
import OrderTradeHistory from '../../components/exchange/OrderTradeHistory'
import UserFounds from '../../components/exchange/UserFounds'
import { getOrderHistoryQS, getOpenOrdersQS } from '../../redux/order/action'
import { getTradeHistoryByAddressQS } from '../../redux/trade/action'
import { getAccount } from '../../redux/account/action'
import zIndex from '../../utils/zIndexScale'
import { withI18n } from '../../i18n/util'
import { getTokenType } from '../../utils/tokenTypes'

const Wrapper = styled.div`
  position: absolute;
  left: 0;
  right: 540px;
  background: ${({ theme }) => theme.exchangeSecondBg};
  height: 250px;
  white-space: nowrap;
  z-index: ${zIndex.tradeOrders};
  @media (max-width: 1320px) {
    overflow-x: auto;
    overflow-y: hidden;
  }
  @media (max-width: 768px) {
    display: none;
  }
`

const TradeOrdersHD = styled.div`
  height: 30px;
  display: flex;
  flex-direction: row;
  box-shadow: ${({ theme }) => theme.exchangeHeadShadow};
  align-items: center;
  padding-left: 4px;
`

const TradeOrdersItem = styled.div`
  padding: 0 5px;
  height: 22px;
  line-height: 23px;
  font-size: 12px;
  margin-right: 6px;
  cursor: pointer;
  border-radius: 2px;
  color: ${({ theme }) => theme.exchangeTabNotSelectedColor};
  transition: color 150ms, background 150ms;

  &:hover {
    background: ${({ theme }) => theme.exchangeTabSelectedBg};
    color: ${({ theme }) => theme.exchangeTabSelectedColor};
  }
`

const SelectedTradeOrdersItems = styled(TradeOrdersItem)`
  background: ${({ theme }) => theme.exchangeTabSelectedBg};
  color: ${({ theme }) => theme.exchangeTabSelectedColor};

  ::after {
    content: ${({ theme }) => theme.exchangeTabSelectedContent};
    display: block;
    width: 16px;
    height: 2px;
    border-radius: 3px;
    background: #4653c8;
    position: relative;
    left: calc(50% - ${16 / 2}px);
  }
`

class TradeOrders extends PureComponent {
  static propTypes = {
    address: PropTypes.string,
    currentTrade: PropTypes.string,
    dispatch: PropTypes.func,
    openOrders: PropTypes.array,
    userInfo: PropTypes.object,
    formatI18nText: PropTypes.func,
  }

  static defaultProps = {
    address: '',
    currentTrade: '',
    openOrders: [],
    userInfo: {},
    dispatch: () => {},
    formatI18nText: () => {},
  }

  constructor(props) {
    super(props)
    this.state = {
      tabs: [
        {
          name: 'Open Orders',
          i18nId: 'header.openOrders',
          selected: true,
        },
        {
          name: 'Order History',
          i18nId: 'header.orderHistory',
          selected: false,
        },
        {
          name: 'Trade History',
          i18nId: 'header.tradeHistory',
          selected: false,
        },
        {
          name: 'Balances',
          i18nId: 'header.balances',
          selected: false,
        },
      ],
      selectedTab: 'Open Orders',
    }
  }

  componentDidMount() {
    this._getOpenOrders()
    this._getOrderHistory()
    this._getOrderTradeHistory()
  }

  _getOpenOrders = opts => {
    const tokenType = getTokenType()
    const { dispatch } = this.props
    let user = sessionStorage.getItem('user')
    user = (user && JSON.parse(user)) || {}
    if (!user.address) {
      return
    }
    const params = {
      address: user.address,
      offset: 0,
      limit: 50,
      ...opts,
    }
    dispatch(getOpenOrdersQS({ params, tokenType }))
  }

  _getOrderHistory = opts => {
    const tokenType = getTokenType()
    const { dispatch } = this.props
    let user = sessionStorage.getItem('user')
    user = (user && JSON.parse(user)) || {}
    if (!user.address) {
      return
    }
    const params = {
      address: user.address,
      offset: 0,
      limit: 50,
      ...opts,
    }
    dispatch(getOrderHistoryQS({ params, withLoading: false, tokenType }))
  }

  _getOrderTradeHistory = opts => {
    const tokenType = getTokenType()
    const { dispatch } = this.props
    let user = sessionStorage.getItem('user')
    user = (user && JSON.parse(user)) || {}
    if (!user.address) {
      return
    }
    const params = {
      address: user.address,
      offset: 0,
      limit: 50,
      ...opts,
    }
    dispatch(getTradeHistoryByAddressQS({ params, withLoading: false, tokenType }))
  }

  buildColumns = () => {
    const columns = [
      {
        title: 'TxHash',
        headerAlign: 'left',
        sorter: true,
        dataIndex: 'txHash',
        key: 'Price',
      },
      {
        title: 'Date',
        dataIndex: 'date',
        headerAlign: 'left',
        sorter: true,
        key: 'Date',
      },
      {
        title: 'Pair',
        dataIndex: 'pair',
        key: 'Pair',
      },
      {
        title: 'Side',
        dataIndex: 'side',
        key: 'Side',
      },
      {
        title: 'Average',
        dataIndex: 'average',
        key: 'Average',
      },
      {
        title: 'Price',
        dataIndex: 'price',
        key: 'Price',
      },
      {
        title: 'Filled',
        dataIndex: 'filled',
        key: 'Filled',
      },
      {
        title: 'Amount',
        dataIndex: 'amount',
        key: 'Amount',
      },
      {
        title: 'Total',
        dataIndex: 'total',
        key: 'Total',
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'Status',
      },
    ]
    return columns
  }

  _selectTab = tabName => {
    const { tabs } = this.state
    let selectedTab = 'Open Orders'
    tabs.forEach(t => {
      if (t.name === tabName) {
        t.selected = true
        selectedTab = tabName
      } else {
        t.selected = false
      }
    })

    this.setState(
      {
        selectedTab,
      },
      () => {
        this._queryByTab(selectedTab)
      }
    )
  }

  _queryByTab = tab => {
    const { dispatch, address } = this.props
    if (!address) {
      return
    }
    if (tab === 'Open Orders') {
      this._getOpenOrders()
    }
    if (tab === 'Order History') {
      this._getOrderHistory()
    }
    if (tab === 'Trade History') {
      this._getOrderTradeHistory()
    }
    if (tab === 'Balances') {
      dispatch(getAccount(address))
    }
  }

  render() {
    const { tabs, selectedTab } = this.state
    const { address, formatI18nText } = this.props

    const tradeOrdersItemOpts = tabs.map((t, index) => {
      if (t.selected) {
        return (
          <SelectedTradeOrdersItems key={index}>
            {formatI18nText(t.i18nId)}
          </SelectedTradeOrdersItems>
        )
      }
      return (
        <TradeOrdersItem
          onClick={() => {
            this._selectTab(t.name)
          }}
          key={index}
        >
          {formatI18nText(t.i18nId)}
        </TradeOrdersItem>
      )
    })

    return (
      <Wrapper className="tradeOrdersWrap">
        <TradeOrdersHD>{tradeOrdersItemOpts}</TradeOrdersHD>
        {selectedTab === 'Open Orders' && <OpenOrders getOpenOrders={this._getOpenOrders} />}
        {selectedTab === 'Order History' && (
          <OrderHistory getOrderHistory={this._getOrderHistory} />
        )}
        {selectedTab === 'Trade History' && (
          <OrderTradeHistory address={address} getOrderTradeHistory={this._getOrderTradeHistory} />
        )}
        {selectedTab === 'Balances' && <UserFounds />}
      </Wrapper>
    )
  }
}

const mapStateToProps = ({
  account: {
    userInfo: { address },
    userInfo,
  },
  exchange: { currentTrade },
  order: { openOrders },
}) => ({
  address,
  userInfo,
  currentTrade,
  openOrders: openOrders.order,
})

export default withI18n(connect(mapStateToProps)(TradeOrders))
